import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, requiredRoles }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const token = localStorage.getItem("access_token");

  // Debug logging
  console.log("🔍 ProtectedRoute Debug:", {
    user: user,
    token: token,
    requiredRoles: requiredRoles,
    localStorageKeys: Object.keys(localStorage),
    allLocalStorage: {
      user: localStorage.getItem("user"),
      access_token: localStorage.getItem("access_token"),
      currentUser: localStorage.getItem("currentUser"),
      userSession: localStorage.getItem("userSession"),
    },
  });

  // If no user or no token
  if (!user || !token) {
    console.log("❌ No user or token found, redirecting to signin");
    return <Navigate to="/signin" replace />;
  }

  // If user role doesn't match the required role(s), redirect to unauthorized page
  if (requiredRoles && !requiredRoles.includes(user.role)) {
    console.log("❌ User role does not match required roles:", {
      userRole: user.role,
      requiredRoles: requiredRoles,
    });
    return <Navigate to="/unauthorized" replace />;
  }

  console.log("✅ Access granted");
  return children;
};

export default ProtectedRoute;
